import React from "react";
import { DisabledPrompt, NavLink, useModel } from "bcms-react";

import "./styles.css";
import { SVGAsset } from "res";

/**
 * @function LoginFooter
 * @param {STRING} fiName - Sets the financial institution name. 
 * @param {STRING} versionNum - Sets the version number.
 * @returns {React.Component}
 * @exported true
 * @description This is the login footer, it is the footer only used on the login page.
 * @example
 * <LoginFooter fiName="MyFinancial" versionNum="2.3.4" />
 */
export default function LoginFooter(props) {
  const { branding } = useModel();
  const options = branding.options;
  const hasLogo = options.affiliation_logo_mabi23 == "FDIC" || options.affiliation_logo_mabi23 == "NCUA";
  const hasFDIC = options.affiliation_logo_mabi23 == "FDIC";
  const hasNCUA = options.affiliation_logo_mabi23 == "NCUA";
  const logo = hasFDIC ?  <SVGAsset id="FDICIcon" className="affiliation-icon set-width fdic-icon" />:
                hasNCUA?<SVGAsset id="NCUAIcon" className="affiliation-icon ncua-icon set-width" /> :<></>;
  const fiName = props.fiName ?? "";
  const versionNum = props.versionNum ?? "";
  return(
    <div className="login-footer flex-container flex-vertical black-transparent-background set-height">
      {/* hidden by default */}
      <div className="login-footer-row flex-container flex-horizontal align-center justify-center flex-height bank-name-version-container hide">
        <div className="left-column flex-width text-right">
          <span className="fi-name-text">{ fiName }</span>
        </div>
        <div className="right-column flex-width">
          <span className="version-number-text">{ versionNum }</span>
        </div>
      </div>
      <div className="login-footer-row flex-container flex-horizontal align-center justify-center flex-height">
        <div className="left-column flex-width text-right">
          <div className="disabled-wrapper">
            <DisabledPrompt>
              <NavLink className="disclaimer-link">Disclaimer</NavLink>
            </DisabledPrompt>
          </div>
        </div>
        <div className="right-column flex-width">
          <DisabledPrompt>
            <NavLink className="privacy-policy-link">Privacy Policy</NavLink>
          </DisabledPrompt> 
        </div>
      </div>
    <div className="login-footer-row flex-container flex-horizontal align-center justify-center flex-height equal-housing-ncua-container">
        <div className="equal-housing-container flex-width text-center">
          <SVGAsset id="EqualHousingLenderIcon" className="equal-housing-icon" />
          <span className="set-width equal-housing">Equal Housing Lender</span>
        </div>
      
        {hasLogo &&  <div className="ncua-container flex-width flex-container align-center">
        {logo}
          <span className="set-width federally-insured">Federally Insured</span>
        </div>
        }
      </div>

    </div>
  );
}